import * as resource from './resource'
import * as types from './mutation-types'

const errorHandler = commit => (err) => {
  commit(types.UPDATE_LOADING, false)
  console.log(err) // eslint-disable-line no-console
  throw err
}

const actions = {
  updateLoading({ commit }, isLoading) {
    commit(types.UPDATE_LOADING, isLoading)
  },

  showToast({ commit }, opts) {
    commit(types.SHOW_TOAST, opts)
  },

  fetchUserInfo({ commit }, userId) {
    // commit(types.UPDATE_LOADING, true)
    return resource.user.get({ id: userId })
    .then(res => res.json())
      .then((data) => {
        // commit(types.UPDATE_LOADING, false)
        commit(types.FETCH_USER_INFO, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  registerUser({ commit }, user) {
    commit(types.UPDATE_LOADING, true)
    return resource.user.save({}, user)
      .then(res => res.json())
      .then((data) => {
        commit(types.UPDATE_LOADING, false)
        commit(types.REGISTER_USER, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  bindMobile({ commit }, { userId, mobile, smsCode, password }) {
    commit(types.UPDATE_LOADING, true)
    return resource.user.update({ id: userId }, { mobile, smsCode, password })
      .then(res => res.json())
      .then((data) => {
        commit(types.UPDATE_LOADING, false)
        commit(types.UPDATE_USER, mobile)
        commit(types.FETCH_USER_INFO, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  modifyMobile({ commit }, { userId, mobile, smsCode, password }) {
    commit(types.UPDATE_LOADING, true)
    return resource.userMobile.update({ id: userId }, { mobile, smsCode, password })
      .then(res => res.json())
      .then((data) => {
        commit(types.UPDATE_LOADING, false)
        commit(types.UPDATE_USER, mobile)
        commit(types.FETCH_USER_INFO, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  resetPassword({ commit }, { mobile, smsCode, password }) {
    commit(types.UPDATE_LOADING, true)
    return resource.userPwd.update({}, { mobile, smsCode, password })
      .then(res => res.json())
      .then(() => {
        commit(types.UPDATE_LOADING, false)
      })
      .catch(errorHandler(commit))
  },

  fetchRecommendMatchList({ commit }) {
    commit(types.UPDATE_LOADING, true)
    return resource.match.get({
      isRecommended: true,
    }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_RECOMMEND_MATCH_LIST, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchRecommendRouteList({ commit }) {
    commit(types.UPDATE_LOADING, true)
    return resource.route.get({
      isRecommended: true,
    }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_RECOMMEND_ROUTE_LIST, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchRecommendCustomList({ commit }) {
    commit(types.UPDATE_LOADING, true)
    return resource.HTTP.get('/api/custom/recommend').then(res => res.json())
      .then((data) => {
        commit(types.FETCH_RECOMMEND_CUSTOM_LIST, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchMatchList({ commit }, params) {
    const { sportId, leagueId, queryString, opts, isAllowC2c, isOversea, offset } = params
    // commit(types.UPDATE_LOADING, true)
    let request = {
      sportId,
      leagueId,
      offset,
    }

    if (sportId) {
      request.sportId = sportId
    }

    if (queryString) {
      request.q = queryString
    }
    if (isOversea != null) {
      request.isOversea = isOversea
    }
    if (isAllowC2c) {
      request.isAllowC2c = isAllowC2c
    }
    if (opts) {
      request = Object.assign({}, request, opts)
    }

    return resource.match.get(request).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_MATCH_LIST, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchLeagueList({ commit }, params) {
    const request = {}
    if (params !== undefined) {
      if (params.isOversea !== undefined) {
        request.isOversea = params.isOversea
      }
      if (params.isAllowC2c !== undefined) {
        request.isAllowC2c = params.isAllowC2c
      }
    }
    // commit(types.UPDATE_LOADING, true)
    return resource.league.get(request).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_LEAGUE_LIST, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchFilterInfo({ commit }, leagueId) {
    // commit(types.UPDATE_LOADING, true)
    return resource.filterInfo.get({ id: leagueId }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_FILTER_INFO, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchMatchIntroduction({ commit }, { matchId, userId }) {
    commit(types.UPDATE_LOADING, true)
    return resource.introduction.get({ id: matchId, userId }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_MATCH_INTRODUCTION, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchMatchDetail({ commit }, matchId) {
    commit(types.UPDATE_LOADING, true)
    return resource.match.get({ id: matchId }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_MATCH_DETAIL, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchMatchDetailForOrder({ commit }, matchId) {
    commit(types.UPDATE_LOADING, true)
    return resource.matchDetail.get({ id: matchId }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_MATCH_DETAIL, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchOrderList({ commit }, query) {
    // commit(types.UPDATE_LOADING, true)
    const { userId, listType } = query
    return resource.order.get({ userId, listType }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_ORDER_LIST, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchOrder({ commit }, query) {
    const { orderId, type } = query
    commit(types.UPDATE_LOADING, true)
    return resource.order.get({ id: orderId, type }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_ORDER, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchAds({ commit }) {
    commit(types.UPDATE_LOADING, true)
    return resource.adv.get().then(res => res.json())
      .then((data) => {
        commit(types.FETCH_ADV, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchRouteList({ commit }, req) {
    commit(types.UPDATE_LOADING, true)
    return resource.route.get(req).then(res => res.json())
      .then((data) => {
        commit(types.UPDATE_LOADING, false)
        commit(types.FETCH_ROUTE_LIST, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchRouteDetail({ commit }, { routeId, userId }) {
    commit(types.UPDATE_LOADING, true)
    return resource.route.get({ id: routeId, userId }).then(res => res.json())
      .then((data) => {
        commit(types.UPDATE_LOADING, false)
        commit(types.FETCH_ROUTE_DETAIL, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchQuestionList({ commit }, req) {
    commit(types.UPDATE_LOADING, true)
    return resource.question.get(req).then(res => res.json())
      .then((data) => {
        commit(types.UPDATE_LOADING, false)
        commit(types.FETCH_QUESTION_LIST, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  addQuestion({ commit }, req) {
    commit(types.UPDATE_LOADING, true)
    return resource.question.save({}, req).then(res => res.json())
      .then((data) => {
        commit(types.UPDATE_LOADING, false)
        commit(types.ADD_QUESTION, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchUserFavourList({ commit }, type) {
    // commit(types.UPDATE_LOADING, true)
    return resource.userFavour.get({ type }).then(res => res.json())
      .then((data) => {
        // commit(types.UPDATE_LOADING, false)
        commit(types.FETCH_USER_FAVOUR, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchRouteCategory({ commit }) {
    resource.HTTP.get('/api/route/category').then(res => res.json())
      .then((data) => {
        commit(types.FETCH_ROUTE_CATEGORY, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchRouteFilter({ commit }, categoryId) {
    resource.HTTP.get('/api/route/filter', { params: { categoryId } }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_ROUTE_FILTER, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  doSearch({ commit }, query) {
    const { text, city } = query
    // commit(types.UPDATE_LOADING, true)
    return resource.HTTP.get('/api/search', { params: { key: text, city } }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_SEARCH_RESULT, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },


  toggleMatchFavour({ commit }, query) {
    const { matchId, add = true } = query
    resource.userFavour.save({}, {
      matchId,
      addFavour: add,
    }).then(res => res.json())
      .then((data) => {
        commit(types.TOGGLE_MATCH_FAVOUR, add)
        // const content = `${add ? '收藏成功' : '已取消'}`
        // commit(types.SHOW_TOAST, { content })
        return data
      })
      .catch(errorHandler(commit))
  },

  toggleRouteFavour({ commit }, { routeId, add = true }) {
    resource.userFavour.save({}, {
      routeId,
      addFavour: add,
    }).then(res => res.json())
      .then((data) => {
        // const content = `${add ? '收藏成功' : '已取消'}`
        commit(types.TOGGLE_ROUTE_FAVOUR, add)
        // commit(types.SHOW_TOAST, { content })
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchRaiders({ commit }, raidersId) {
    commit(types.UPDATE_LOADING, true)
    return resource.raiders.get({ id: raidersId }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_RAIDERS, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取观赛筛选选项
  fetchCustomFilterInfo({ commit }, filter = {}) {
    // commit(types.UPDATE_LOADING, true)
    return resource.customFilterInfo.get(filter).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CUSTOM_FILTER_INFO, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取对应运动游线路达人分享列表
  fetchSportsRaidersList({ commit }, sportsRouteId) {
    commit(types.UPDATE_LOADING, true)
    return resource.HTTP.get('/api/custom/sportRaiders', { params: { sportsRouteId } }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_SPORTS_RAIDERS_LIST, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
  },

  // 获取频道栏
  fetchCustomRouteCategoryList({ commit }) {
    // commit(types.UPDATE_LOADING, true)
    return resource.HTTP.get('/api/custom/category').then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CUSTOM_ROUTE_CATEGORY_LIST, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
  },

  // 获取对应的线路(观赛游 or 运动游)
  fetchCustomRouteById({ commit }, params) {
    const { kind, customId } = params
    commit(types.UPDATE_LOADING, true)
    return resource.custom.get({
      id: customId,
      kind,
    }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CUSTOM_ROUTE_BY_ID, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取线路列表(观赛游，运动游)
  fetchCustomRouteList({ commit }, params) {
    const { categoryId, opts, customType = 0 } = params
    // commit(types.UPDATE_LOADING, true)
    let request = {
      categoryId,
      customType,
    }
    if (opts) {
      request = Object.assign({}, request, opts)
    }

    return resource.custom.get(request).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CUSTOM_ROUTE_LIST, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取对应的订单
  fetchCustomOrder({ commit }, params) {
    commit(types.UPDATE_LOADING, true)

    return resource.customOrder.get(params).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CUSTOM_ORDER, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取对应的定制需求
  fetchCustomOrderServices({ commit }, params) {
    commit(types.UPDATE_LOADING, true)
    return resource.HTTP.get('/api/custom/services', { query: params }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CUSTOM_ORDER_SERVICES, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 增加获取BasicConfig的action
  fetchBasicConfig({ commit }) {
    return resource.HTTP.get('/api/config').then(res => res.json())
      .then(data => data)
      .catch(errorHandler(commit))
  },

  // 获取常用信息-联系人
  fetchUserAttnByUserId({ commit }, id) {
    // commit(types.UPDATE_LOADING, true)
    return resource.attn.get({ userId: id }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_USER_ATTN_BY_USERID, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取常用信息-实名信息
  fetchUserRealNameByUserId({ commit }, id) {
    // commit(types.UPDATE_LOADING, true)
    return resource.realNameInfo.get({ userId: id }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_USER_REAL_NAME_BY_USERID, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取常用信息-常用地址
  fetchUserAddressByUserId({ commit }, id) {
    // commit(types.UPDATE_LOADING, true)
    return resource.address.get({ userId: id }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_USER_ADDRESS_BY_USERID, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取默认联系人
  fetchUserCommonAttnByUserId({ commit }, id) {
    commit(types.UPDATE_LOADING, true)
    return resource.commonAttn.get({ userId: id }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_USER_COMMON_ATTN_BY_USERID, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取世界杯赛事
  fetchWorldCupMatchList({ commit }, params) {
    return resource.worldCupMatch.get(params).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_WORLD_CUP_MATCH_LIST, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取跟团游线路详情
  fetchTourDetail({ commit }, params) {
    commit(types.UPDATE_LOADING, true)
    return resource.tourDetail.get(params).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_TOUR_DETAIL, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取跟团游对应的订单
  fetchTourOrder({ commit }, params) {
    commit(types.UPDATE_LOADING, true)

    return resource.tourOrder.get(params).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_TOUR_ORDER, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchCtcSellingOrderList({ commit }, params) {
    return resource.HTTP.post('/api/ctcOrder/sellingOrderList', params).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CTC_SELLING_ORDER_BY_USERID, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchCtcSoldOrderList({ commit }, params) {
    return resource.HTTP.post('/api/ctcOrder/soldOrderList', params).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_CTC_SOLD_ORDER_BY_USERID, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchCtcBuyerOrder({ commit }, orderId) {
    return resource.HTTP.get(`/api/ctcOrder/buyOrderDetail/${orderId}`).then(resp => resp.json())
      .then((data) => {
        commit(types.FETCH_CTC_BUYER_ORDER, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  fetchCtcSellerOrder({ commit }, orderId) {
    return resource.HTTP.get(`/api/ctcOrder/sellingOrderDetail/${orderId}`).then(resp => resp.json())
      .then((data) => {
        commit(types.FETCH_CTC_SELLER_ORDER, data)
        return data
      })
      .catch(errorHandler(commit))
  },

  savePayPassword({ commit }, payPassword) {
    commit(types.SAVE_WALLET_PAY_PASSWORD, payPassword)
  },

  saveBindingBankCard({ commit }, bindingBankCard) {
    commit(types.SAVE_BINDING_BANK_CARD, bindingBankCard)
  },

  saveIsPayPassword({ commit }, isPayPassword) {
    commit(types.SAVE_IS_PAY_PWD, isPayPassword)
  },

  saveDrawCashBankCard({ commit }, drawCashBankCard) {
    commit(types.SAVE_DRAW_CASH_BANK_CARD, drawCashBankCard)
  },

  // 获取体育游列表(定制游，跟团游)
  fetchSportsTourRouteList({ commit }, params) {
    const { categoryId, routeType, opts, offset } = params
    // commit(types.UPDATE_LOADING, true)
    let request = {
      categoryId,
      routeType,
      offset,
    }
    if (opts) {
      request = Object.assign({}, request, opts)
    }
    return resource.sportsTour.get(request).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_SPORTS_TOUR_ROUTE_LIST, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取体育游筛选选项
  fetchSportsTourFilterInfo({ commit }, filter) {
    // commit(types.UPDATE_LOADING, true)
    return resource.sportsTourFilterInfo.get(filter).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_SPORTS_TOUR_FILTER_INFO, data)
        // commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取体育游对应的线路(定制游 or 跟团游)
  fetchSportsTourRouteById({ commit }, params) {
    const { routeId } = params
    commit(types.UPDATE_LOADING, true)
    return resource.sportsTour.get({
      id: routeId,
    }).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_SPORTS_TOUR_ROUTE_BY_ID, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },

  // 获取旅游订单列表
  fetchTravelOrderList({ commit }, params) {
    commit(types.UPDATE_LOADING, true)

    return resource.travelOrder.get(params).then(res => res.json())
      .then((data) => {
        commit(types.FETCH_TRAVEL_ORDER_LIST, data)
        commit(types.UPDATE_LOADING, false)
        return data
      })
      .catch(errorHandler(commit))
  },
}

export default actions



// WEBPACK FOOTER //
// ./client/vuex/actions.js